var _defs, _rect, _path, _rect2, _rect3, _path2, _rect4, _path3, _rect5, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCubo3X3Normal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cubo3x3normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 355.78,
    width: 156.22,
    height: 156.22,
    rx: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.89,355.78h56.22a50,50,0,0,1,50,50V482a30,30,0,0,1-30,30H207.89a30,30,0,0,1-30-30V405.78A50,50,0,0,1,227.89,355.78Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 355.78,
    y: 355.78,
    width: 156.22,
    height: 156.22,
    rx: 30
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 156.22,
    height: 156.22,
    rx: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.89,0h96.22a30,30,0,0,1,30,30v76.22a50,50,0,0,1-50,50H227.89a50,50,0,0,1-50-50V30A30,30,0,0,1,207.89,0Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 355.78,
    width: 156.22,
    height: 156.22,
    rx: 30
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,177.89h76.22a50,50,0,0,1,50,50v56.22a50,50,0,0,1-50,50H30a30,30,0,0,1-30-30V207.89A30,30,0,0,1,30,177.89Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.5,
    y: 178.5,
    width: 155,
    height: 155,
    rx: 70
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.78,177.89H482a30,30,0,0,1,30,30v96.22a30,30,0,0,1-30,30H405.78a50,50,0,0,1-50-50V227.89A50,50,0,0,1,405.78,177.89Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubo3X3Normal);
export default __webpack_public_path__ + "static/media/cubo3x3normal.d27ddf325abb648aac8acdad53d5ee71.svg";
export { ForwardRef as ReactComponent };